// lib/stayCancellation.js, pages/hotels/PropertySections.jsx, HomeStaySections.jsx:
// a stay listed on Toukky by its partner is refundable for 24 hours after
// booking, and since 2026-10-23 not after them (every new booking reads
// "non_refundable"); a booking made before keeps the policy it was sold with
// (backend/modules/bookings/stay_cancellation.py). A traveller reads it as a
// date and a time, "free cancellation until ..." (owner, 2026-10-24).
export const cancellationTermsL = {
  en: {
    closedBeforePay: "Once paid, this booking can't be cancelled free of charge: the free cancellation period has already ended.",
    freeUntil: (when) => `Free cancellation until ${when}`,
    passed: "The free cancellation period has ended. Contact support to cancel.",
    policy: { flexible: "Flexible", moderate: "Moderate", non_refundable: "Non-refundable" },
    rule: { flexible: "full refund up to 24 hours before arrival.", moderate: "full refund up to 5 days before arrival.", non_refundable: "no refund." },
    conditions: "The owner's conditions",
    policyLabel: "Cancellation",
  },
  fr: {
    closedBeforePay: "Une fois payée, cette réservation ne pourra plus être annulée gratuitement : le délai d'annulation gratuite est déjà passé.",
    freeUntil: (when) => `Annulation gratuite jusqu'au ${when}`,
    passed: "Le délai d'annulation gratuite est passé. Contactez l'assistance pour annuler.",
    policy: { flexible: "Flexible", moderate: "Modérée", non_refundable: "Non remboursable" },
    rule: { flexible: "remboursement intégral jusqu'à 24 h avant l'arrivée.", moderate: "remboursement intégral jusqu'à 5 jours avant l'arrivée.", non_refundable: "aucun remboursement." },
    conditions: "Les conditions du propriétaire",
    policyLabel: "Annulation",
  },
  es: {
    closedBeforePay: "Una vez pagada, esta reserva no podrá cancelarse gratis: el plazo de cancelación gratuita ya ha terminado.",
    freeUntil: (when) => `Cancelación gratuita hasta el ${when}`,
    passed: "El plazo de cancelación gratuita ha terminado. Contacta con asistencia para cancelar.",
    policy: { flexible: "Flexible", moderate: "Moderada", non_refundable: "No reembolsable" },
    rule: { flexible: "reembolso completo hasta 24 horas antes de la llegada.", moderate: "reembolso completo hasta 5 días antes de la llegada.", non_refundable: "sin reembolso." },
    conditions: "Las condiciones del propietario",
    policyLabel: "Cancelación",
  },
  pt: {
    closedBeforePay: "Depois de paga, esta reserva não poderá ser cancelada gratuitamente: o prazo de cancelamento gratuito já terminou.",
    freeUntil: (when) => `Cancelamento gratuito até ${when}`,
    passed: "O prazo de cancelamento gratuito terminou. Contacte o apoio para cancelar.",
    policy: { flexible: "Flexível", moderate: "Moderada", non_refundable: "Não reembolsável" },
    rule: { flexible: "reembolso total até 24 horas antes da chegada.", moderate: "reembolso total até 5 dias antes da chegada.", non_refundable: "sem reembolso." },
    conditions: "As condições do proprietário",
    policyLabel: "Cancelamento",
  },
  ar: {
    closedBeforePay: "بعد الدفع، لا يمكن إلغاء هذا الحجز مجانًا: فقد انتهت مهلة الإلغاء المجاني.",
    freeUntil: (when) => `إلغاء مجاني حتى ${when}`,
    passed: "انتهت مهلة الإلغاء المجاني. تواصل مع الدعم للإلغاء.",
    policy: { flexible: "مرنة", moderate: "معتدلة", non_refundable: "غير قابلة للاسترداد" },
    rule: { flexible: "استرداد كامل حتى 24 ساعة قبل الوصول.", moderate: "استرداد كامل حتى 5 أيام قبل الوصول.", non_refundable: "لا استرداد." },
    conditions: "شروط المالك",
    policyLabel: "الإلغاء",
  },
  zh: {
    closedBeforePay: "付款后，此预订将无法免费取消：免费取消期限已过。",
    freeUntil: (when) => `${when} 前可免费取消`,
    passed: "免费取消期限已过。如需取消，请联系客服。",
    policy: { flexible: "灵活", moderate: "适中", non_refundable: "不可退款" },
    rule: { flexible: "入住前 24 小时可全额退款。", moderate: "入住前 5 天可全额退款。", non_refundable: "不予退款。" },
    conditions: "房东的条件",
    policyLabel: "取消政策",
  },
};

// A car a company rents out on Toukky (owner, 2026-10-23): its own
// conditions go with the free cancellation date (backend stay_cancellation.VEHICLE_RULE).
export const rentalTermsL = {
  en: { conditions: "The rental company's conditions" },
  fr: { conditions: "Les conditions du loueur" },
  es: { conditions: "Las condiciones de la empresa de alquiler" },
  pt: { conditions: "As condições da empresa de aluguer" },
  ar: { conditions: "شروط شركة التأجير" },
  zh: { conditions: "租车公司的条件" },
};
